export const CONNECTED_DISCONNECT_OVERLAY: Record<string, any> = {
  en: { connected: { disconnect: {
    deleteWarning: "Delete your copy of this Connected Match? This will disconnect the match for both players and remove it from BOTH players' Elo rankings. The other player's private copy will be kept.",
    title: "Disconnect this match",
    body: "Stop syncing this match with the other player. Both players keep their own copy.",
    action: "Disconnect match",
    dialogTitle: "Disconnect this Connected Match?",
    dialogBody: "Both players will keep their current match copy. From then on, the two copies become independent and future edits will no longer sync.",
    pendingCorrectionNote: "If a correction request is pending, it will be withdrawn. Private notes, ratings, readiness and health/watch data are not changed.",
    cancel: "Cancel",
    confirm: "Disconnect match",
    success: "Match disconnected. Both private copies were kept.",
    error: "Could not disconnect this Connected Match.",
  } } },
  el: { connected: { disconnect: {
    deleteWarning: "Να διαγραφεί το δικό σου αντίγραφο αυτού του Connected Match; Ο αγώνας θα αποσυνδεθεί και θα αφαιρεθεί από το Elo ΚΑΙ των δύο παικτών. Το προσωπικό αντίγραφο του αντιπάλου θα διατηρηθεί.",
    title: "Αποσύνδεση αυτού του αγώνα",
    body: "Σταμάτησε τον συγχρονισμό αυτού του αγώνα με τον άλλο παίκτη. Και οι δύο κρατάτε το δικό σας αντίγραφο.",
    action: "Αποσύνδεση αγώνα",
    dialogTitle: "Αποσύνδεση αυτού του Connected Match;",
    dialogBody: "Και οι δύο παίκτες θα κρατήσετε το τρέχον αντίγραφο του αγώνα. Από εκεί και πέρα, τα δύο αντίγραφα γίνονται ανεξάρτητα και οι μελλοντικές αλλαγές δεν θα συγχρονίζονται.",
    pendingCorrectionNote: "Αν εκκρεμεί αίτημα διόρθωσης, θα ανακληθεί. Προσωπικές σημειώσεις, αξιολογήσεις, readiness και δεδομένα υγείας/watch δεν αλλάζουν.",
    cancel: "Ακύρωση",
    confirm: "Αποσύνδεση αγώνα",
    success: "Ο αγώνας αποσυνδέθηκε. Και τα δύο ιδιωτικά αντίγραφα διατηρήθηκαν.",
    error: "Δεν ήταν δυνατή η αποσύνδεση αυτού του Connected Match.",
  } } },
  es: { connected: { disconnect: {
    deleteWarning: "¿Eliminar tu copia de este Connected Match? El partido se desconectará y dejará de contar en el Elo de AMBOS jugadores. La copia privada del otro jugador se conservará.",
    title: "Desconectar este partido",
    body: "Deja de sincronizar este partido con el otro jugador. Ambos conservarán su propia copia.",
    action: "Desconectar partido",
    dialogTitle: "¿Desconectar este Connected Match?",
    dialogBody: "Ambos jugadores conservarán su copia actual del partido. A partir de entonces, las dos copias serán independientes y los cambios futuros dejarán de sincronizarse.",
    pendingCorrectionNote: "Si hay una solicitud de corrección pendiente, se retirará. Las notas privadas, valoraciones, preparación y datos de salud/reloj no se modificarán.",
    cancel: "Cancelar",
    confirm: "Desconectar partido",
    success: "Partido desconectado. Se conservaron ambas copias privadas.",
    error: "No se pudo desconectar este Connected Match.",
  } } },
  fr: { connected: { disconnect: {
    deleteWarning: "Supprimer votre copie de ce Connected Match ? Le match sera déconnecté et retiré de l’Elo des DEUX joueurs. La copie privée de l’autre joueur sera conservée.",
    title: "Déconnecter ce match",
    body: "Arrêtez la synchronisation de ce match avec l’autre joueur. Chacun conserve sa propre copie.",
    action: "Déconnecter le match",
    dialogTitle: "Déconnecter ce Connected Match ?",
    dialogBody: "Les deux joueurs conserveront leur copie actuelle du match. Ensuite, les deux copies deviendront indépendantes et les futures modifications ne seront plus synchronisées.",
    pendingCorrectionNote: "Si une demande de correction est en attente, elle sera retirée. Les notes privées, évaluations, données de préparation et de santé/montre ne seront pas modifiées.",
    cancel: "Annuler",
    confirm: "Déconnecter le match",
    success: "Match déconnecté. Les deux copies privées ont été conservées.",
    error: "Impossible de déconnecter ce Connected Match.",
  } } },
  de: { connected: { disconnect: {
    deleteWarning: "Deine Kopie dieses Connected Match löschen? Das Match wird getrennt und aus der Elo-Wertung BEIDER Spieler entfernt. Die private Kopie des anderen Spielers bleibt erhalten.",
    title: "Dieses Match trennen",
    body: "Beende die Synchronisierung dieses Matches mit dem anderen Spieler. Beide behalten ihre eigene Kopie.",
    action: "Match trennen",
    dialogTitle: "Dieses Connected Match trennen?",
    dialogBody: "Beide Spieler behalten ihre aktuelle Matchkopie. Danach sind die beiden Kopien unabhängig und zukünftige Änderungen werden nicht mehr synchronisiert.",
    pendingCorrectionNote: "Eine offene Korrekturanfrage wird zurückgezogen. Private Notizen, Bewertungen, Bereitschafts- sowie Gesundheits-/Watch-Daten bleiben unverändert.",
    cancel: "Abbrechen",
    confirm: "Match trennen",
    success: "Match getrennt. Beide privaten Kopien wurden beibehalten.",
    error: "Dieses Connected Match konnte nicht getrennt werden.",
  } } },
  it: { connected: { disconnect: {
    deleteWarning: "Eliminare la tua copia di questo Connected Match? La partita verrà scollegata e rimossa dall’Elo di ENTRAMBI i giocatori. La copia privata dell'altro giocatore sarà conservata.",
    title: "Disconnetti questa partita",
    body: "Interrompi la sincronizzazione di questa partita con l’altro giocatore. Entrambi conserverete la vostra copia.",
    action: "Disconnetti partita",
    dialogTitle: "Disconnettere questo Connected Match?",
    dialogBody: "Entrambi i giocatori conserveranno la copia attuale della partita. Da quel momento le due copie saranno indipendenti e le modifiche future non verranno più sincronizzate.",
    pendingCorrectionNote: "Se c’è una richiesta di correzione in sospeso, verrà ritirata. Note private, valutazioni, readiness e dati salute/watch non saranno modificati.",
    cancel: "Annulla",
    confirm: "Disconnetti partita",
    success: "Partita disconnessa. Entrambe le copie private sono state conservate.",
    error: "Impossibile disconnettere questo Connected Match.",
  } } },
  ja: { connected: { disconnect: {
    deleteWarning: "この Connected Match の自分の記録を削除しますか？連携が解除され、両選手の Elo ランキングからこの試合が除外されます。相手の非公開記録は保持されます。",
    title: "この試合の連携を解除",
    body: "この試合の相手との同期を停止します。両方の選手にそれぞれの記録が残ります。",
    action: "試合の連携を解除",
    dialogTitle: "この Connected Match の連携を解除しますか？",
    dialogBody: "両選手には現在の試合記録が残ります。解除後は2つの記録が独立し、今後の変更は同期されません。",
    pendingCorrectionNote: "保留中の修正リクエストがある場合は取り下げられます。非公開のメモ、評価、コンディション、健康・ウォッチデータは変更されません。",
    cancel: "キャンセル",
    confirm: "試合の連携を解除",
    success: "試合の連携を解除しました。両方の非公開記録は保持されています。",
    error: "この Connected Match の連携を解除できませんでした。",
  } } },
};
